module.exports = __webpack_public_path__ + "quilt2.ff1eeadf.png";